import { useState } from 'react';
import { getInitials } from '../../lib/format';

const HR_IMAGE_BASE = 'https://api-hr.boonsiri.co.th/public/images/profile';

export default function ProfileAvatar({ empCode, fullName, size = 34, style }) {
  const [imgError, setImgError] = useState(false);
  const src = empCode ? `${HR_IMAGE_BASE}/${empCode}_1.jpg` : null;

  return (
    <div
      className="user-avatar"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        overflow: 'hidden',
        flexShrink: 0,
        ...style,
      }}
    >
      {src && !imgError ? (
        <img
          src={src}
          alt=""
          onError={() => setImgError(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'top',
            borderRadius: 'inherit',
          }}
        />
      ) : (
        getInitials(fullName)
      )}
    </div>
  );
}
